import React from 'react';
import { useLottie } from "lottie-react";

function LottieAnimation(props) {
    const { loop, animateFile, height, width } = props;
    const options = {
        animationData: animateFile,
        loop: true
    };
    const { View } = useLottie(options);
    return (
        <>
            {View}
        </>
       

    );
}

export default LottieAnimation;